import { jsxs as m, jsx as e } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as d } from "../../../context/theme/hooks.js";
import { isButton as f, isButtonLink as g } from "../../../utils/isButton.js";
import { I as x, B as h } from "../../../ActionButton-B77eJAd5.js";
import "react";
import b from "../Icon/Icon.js";
import "../../layout/Stack/Stack.js";
import s from "../../layout/Box/Box.js";
import c from "../../layout/Inline/Inline.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../../index-CZ8zjHGv.js";
import "focus-trap-react";
import B from "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import I from "../../controls/ButtonLink/ButtonLink.js";
import "@material/material-color-utilities";
import "../Logo/consts.js";
import "react-select";
import "react-select/async";
import "../../controls/Toggle/CustomCheckbox.js";
function _({
  tone: r = "primary",
  width: o,
  iconName: t,
  buttonProps: i,
  children: l,
  onCloseClick: n,
  justifyContent: a = "space-between"
}) {
  const { backgroundColor: p, borderColor: u } = w(r);
  return /* @__PURE__ */ m(
    s,
    {
      width: o,
      display: "flex",
      paddingX: "12",
      paddingY: "large",
      alignItems: "center",
      justifyContent: a,
      backgroundColor: p,
      borderStyle: "solid",
      borderRadius: "small",
      borderWidth: "xxxsmall",
      borderColor: u,
      children: [
        /* @__PURE__ */ m(c, { space: "large", flexWrap: "nowrap", alignItems: "center", children: [
          t && /* @__PURE__ */ e(
            b,
            {
              tone: r,
              size: "xlarge",
              iconName: t,
              accessibilityLabel: t
            }
          ),
          l && /* @__PURE__ */ e(C, { body: l, tone: r })
        ] }),
        /* @__PURE__ */ e(s, { marginLeft: "xlarge", children: /* @__PURE__ */ m(c, { space: "large", flexWrap: "nowrap", alignItems: "center", children: [
          /* @__PURE__ */ e(k, { buttonProps: i, tone: r }),
          /* @__PURE__ */ e(y, { onCloseClick: n, tone: r })
        ] }) })
      ]
    }
  );
}
function C({
  body: r,
  tone: o
}) {
  return typeof r == "string" ? /* @__PURE__ */ e(B, { tone: o, children: r }) : /* @__PURE__ */ e(s, { children: r });
}
function y({
  onCloseClick: r,
  tone: o
}) {
  return r ? /* @__PURE__ */ e(
    x,
    {
      tone: o,
      blend: !0,
      size: "small",
      onClick: r,
      accessibilityLabel: "close",
      iconName: "cross"
    }
  ) : null;
}
function k({
  buttonProps: r,
  tone: o
}) {
  if (!r) return null;
  const t = { size: "small", fill: "outlined" }, { text: i } = r;
  return f(r) ? /* @__PURE__ */ e(h, { tone: o, ...r, ...t, children: i }) : g(r) ? /* @__PURE__ */ e(I, { tone: o, ...r, ...t, children: i }) : null;
}
function w(r) {
  const o = d(), t = `${r}-low-surface`, i = o[t], l = `${r}-low-content`, n = o[l];
  return { backgroundColor: i, borderColor: n };
}
export {
  _ as default
};
